import * as React from "react";

const RightBlackIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} fill="none" {...props}>
    <g clipPath="url(#a)">
      <rect width={26} height={26} fill="#334155" rx={13} />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M7.85 7.85a.923.923 0 0 1 1.297 0l4.584 4.518a.897.897 0 0 1 0 1.278l-4.584 4.518a.924.924 0 0 1-1.285-.01.897.897 0 0 1-.011-1.267l3.935-3.88-3.935-3.88a.897.897 0 0 1 0-1.278Zm5.501 0a.923.923 0 0 1 1.296 0l4.584 4.518a.898.898 0 0 1 0 1.278l-4.584 4.518a.924.924 0 0 1-1.285-.01.897.897 0 0 1-.01-1.267l3.934-3.88-3.935-3.88a.897.897 0 0 1 0-1.278Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect width={26} height={26} fill="#fff" rx={13} />
      </clipPath>
    </defs>
  </svg>
);
export default RightBlackIcon;
